import { User } from 'generated/graphql';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import { Box, Flex } from 'reflexbox';

export default function EvaluationAnswerLine({
	children,
	user,
	side,
	withAvatar = false,
}: {
	children: React.ReactNode;
	side: 'left' | 'right';
	withAvatar?: boolean;
	user: User;
}) {
	return (
		<Flex
			flexGrow={1}
			flexDirection={['column', side === 'left' ? 'row' : 'row-reverse']}
			mr={[0, side === 'left' ? 47 : 0]}
			ml={[0, side === 'right' ? 47 : 0]}
			mt={20}
			style={{ gap: 10 }}
		>
			<Box flexShrink={0} flexGrow={0} opacity={withAvatar ? 1 : 0}>
				<PersonAvatar size={PersonAvatarSize.Medium} person={user} />
			</Box>
			{children}
		</Flex>
	);
}
